<template>
  <div v-show="!isVisible" :class="{'active': !isDesktop && floatActive }" class="promotion_floating">
    <button type="button" class="promotion_floating_close" @click="floatActive = false"><span class="blind">닫기</span></button>
    <div class="promotion_floating_inner">
      <div class="promotion_floating_info">
        <div class="product_option">
          <span class="option_title">학습기간</span>
          <div class="select_box">
            <select :value="selectedProductKey" title="수강 신청할 학습기간 선택" @change="changeProduct($event)">
              <option
                v-for="(productObj, idx) in productList" :key="idx"
                :value="productObj.eduGrpCd+'|@|'+productObj.corsCd+'|@|'+productObj.corsYr+'|@|'+productObj.corsDgrCd">
                {{ $moment(productObj.eduStartDtm, 'YYYYMMDDHH').isValid() ? $moment(productObj.eduStartDtm, 'YYYYMMDDHH').format('YYYY.MM.DD') : productObj.eduStartDtm }}
                ~
                {{ $moment(productObj.eduEndDtm, 'YYYYMMDDHH').isValid() ? $moment(productObj.eduEndDtm, 'YYYYMMDDHH').format('YYYY.MM.DD') : productObj.eduEndDtm }}
              </option>
            </select>
          </div>
        </div>
        <div class="product_payment">
          <strong class="payment_text">총 금액<em class="payment_tax">{{ Number(selectedProduct.ucstTaxAmt) > 0 ? '(VAT포함)' : '(VAT없음)' }}</em></strong>
          <span class="payment_sum">{{ selectedProduct.ucstSmtotAmt | numFormat }}<em class="payment_unit"> 원</em></span>
        </div>
      </div>
      <div class="btn_product_wrap promotion_floating_btn">
        <button :style="selectedProduct.ucstSmtotAmt > 0 ? {display:'block'} : {display:'none'}" type="button" class="btn_product ico_product" @click="addCart"><span class="btn_text">장바구니</span></button>
        <button type="button" class="btn_product" @click="order"><span class="btn_text">수강신청</span></button>
      </div>
    </div>
  </div>
</template>

<script>
import { isEmpty, find } from 'lodash'

export default {
  name: 'MmpPromoCartFloat',
  data () {
    return {
      floatActive: false
    }
  },
  computed: {
    promoInfoStore () {
      return window.vue.getStore('promoInfo')
    },
    productList () {
      return this.promoInfoStore.state.productDetail.productList
    },
    selectedProductKey () {
      return this.promoInfoStore.state.productDetail.selectedProductKey
    },
    isDesktop () {
      return this.$utils.userAgent.isDesktop()
    },
    isVisible () {
      if (this.isDesktop) {
        return this.promoInfoStore.state.productDetail.isVisible
      } else {
        return false
      }
    },
    selectedProduct () {
      if (isEmpty(this.selectedProductKey)) {
        return {}
      }

      var splitArray = this.selectedProductKey.split('|@|')

      var selectKeyObj = {
        eduGrpCd: splitArray[0],
        corsCd: splitArray[1],
        corsYr: splitArray[2],
        corsDgrCd: splitArray[3]
      }

      var findObj = find(this.productList, selectKeyObj)

      return findObj
    },
    shareCopyUrl () {
      return window.location.href
    }
  },
  mounted () {
  },
  methods: {
    changeProduct (e) {
      this.promoInfoStore.commit('SET_PRODUCT_SELECTED', e.target.value)
    },
    visibilityChanged (isVisible, entry) {
      this.promoInfoStore.commit('SET_PRODUCT_VISIBLE', isVisible)
    },
    toastCopySuccess (e) {
      console.log(e)
      // this.$popup.toast('URL이 복사되었습니다.')
      this.snsLinkOpen = false
    },
    addCart () {
      this.$parent.addCart()
    },
    order () {
      if (this.isDesktop) {
        this.$parent.order()
      } else {
        if (!this.floatActive) {
          this.floatActive = true
        } else {
          this.floatActive = false
          this.$parent.order()
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/contents/promotion/MmpPromoCartFloat.vue